const framePage = {
	allowSubmit: true,
	facebookAllowSubmit: true
};

export default framePage;



// WEBPACK FOOTER //
// ./app/public/src/js/signin/frame/utils/framePage.js